module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bdmA2"))).then(() => parcelRequire('8rm4T'));